import { defineStore } from 'pinia'

export const useErrorStore = defineStore('errorStore', {
  state: () => ({
    errors: [] as string[],
  }),
  actions: {
    addError(error: string) {
      this.errors.push(error)
    },
    clearErrors() {
      this.errors = []
    },
    removeError(idx: number) {
      this.errors.splice(idx, 1)
    },
  },
})
